import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

/// Altura comum dos controles da barra, para ficarem alinhados.
export const CONTROL_HEIGHT = '43px';

/// Duas linhas: ao lado dos controles (~740px) as métricas quebrariam em notebook.
export const barSx = (cc: CrmColors): SxProps<Theme> => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 1.1,
    mb: 1.5,
    pb: 1.5,
    borderBottom: `1px solid ${cc.divider}`,
});

export const TOP_ROW_SX: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 1.5, rowGap: 1.25, flexWrap: 'wrap' };

/// Sem espaço, os controles quebram para a linha de baixo, à direita.
export const CONTROLS_SX: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: 1.5,
    rowGap: 1.25,
    flexShrink: 0,
    maxWidth: '100%',
    ml: 'auto',
};

export const boardNameSx = (cc: CrmColors): SxProps<Theme> => ({
    fontSize: 25,
    fontWeight: 700,
    letterSpacing: '-.2px',
    color: cc.textPrimary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
});

export const boardColorSx = (color: string): SxProps<Theme> => ({
    width: 12,
    height: 12,
    borderRadius: '3px',
    bgcolor: color,
    flexShrink: 0,
});

export const viewToggleSx = (cc: CrmColors): SxProps<Theme> => ({
    height: CONTROL_HEIGHT,
    bgcolor: cc.surfaceBg,
    borderRadius: '9px',
    '& .MuiToggleButton-root': {
        gap: 0.6,
        px: 1.25,
        border: `1px solid ${cc.border}`,
        color: cc.textSecondary,
        fontSize: '12.5px',
        fontWeight: 700,
        textTransform: 'none',
        '&:hover': { bgcolor: cc.countBg },
    },
    '& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover': {
        bgcolor: cc.accentSoftBg,
        color: cc.accent,
        borderColor: cc.accent,
    },
    '& .MuiToggleButtonGroup-firstButton': { borderRadius: '9px 0 0 9px' },
    '& .MuiToggleButtonGroup-lastButton': { borderRadius: '0 9px 9px 0' },
});

export const searchFieldSx = (cc: CrmColors): SxProps<Theme> => ({
    width: 190,
    '& .MuiOutlinedInput-root': {
        height: CONTROL_HEIGHT,
        bgcolor: cc.surfaceBg,
        borderRadius: '5px',
        color: cc.textPrimary,
        '& fieldset': { borderColor: cc.border },
        '&:hover fieldset': { borderColor: cc.borderStrong },
    },
    '& input': { color: cc.textPrimary },
    '& input::placeholder': { color: cc.textMuted, opacity: 1 },
});

/// Botão de ícone da barra; `active` pinta com o destaque, como um filtro ligado.
export const iconButtonSx = (cc: CrmColors, active: boolean, color: string): SxProps<Theme> => ({
    bgcolor: active ? cc.accentSoftBg : cc.surfaceBg,
    border: `1px solid ${active ? cc.accent : cc.border}`,
    borderRadius: '9px',
    color: active ? cc.accent : color,
    '&:hover': { bgcolor: cc.countBg, borderColor: cc.borderStrong },
});

export const pickerButtonSx = (cc: CrmColors): SxProps<Theme> => ({
    bgcolor: cc.surfaceBg,
    border: `1px solid ${cc.borderStrong}`,
    borderRadius: '10px',
    color: cc.textPrimary,
    textTransform: 'none',
    alignItems: 'center',
    justifyContent: 'flex-start',
    py: 0.75,
    px: 2,
    '&:hover': { bgcolor: cc.surfaceBg, border: `1px solid ${cc.borderStrong}` },
});

export const pickerLabelSx = (cc: CrmColors): SxProps<Theme> => ({
    fontSize: '10.5px',
    fontWeight: 700,
    letterSpacing: '.6px',
    color: cc.textMuted,
});
